import styled from "styled-components";
import smile from "assets/images/thop-surf/smile.png";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0;
  background-image: url(${smile}),
    /* Imagem de Fundo (AGORA POR CIMA) */
      linear-gradient(
        /* Gradiente (AGORA POR BAIXO, e semitransparente) */ 180deg,
        rgba(255, 214, 130, 0.8),
        /* Ajustado para semitransparente */ rgba(236, 191, 121, 0.8),
        /* Ajustado para semitransparente */ rgba(250, 109, 122, 0.8)
          /* Ajustado para semitransparente */
      );
  padding: 100px 50px 0 50px;
`;
export const AreaVideo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  background: gold;
  margin-bottom: 100px;
`;

export const AtletasVideo = styled.video`
  display: flex;
  height: 600px;
  width: auto;
  border: 10px solid #fff;
`;
